import { useQuery } from "@apollo/client";

import { GET_INTENT_PROJECT } from "./gql";

const useIntentProject = (intentProjectId: string | undefined) => {
  const { data, loading, error } = useQuery(GET_INTENT_PROJECT, {
    variables: { id: intentProjectId || "" },
    skip: !intentProjectId,
  });

  return {
    intentProject: data?.intentProject,
    loading,
    error,
  };
};

export default useIntentProject;
